// Per-feature weights sent with every scoring request. The backend's MAUT model
// takes a weighted mean across features, so these decide how much each one
// counts. Every surface that asks the API to score a laptop must send the same
// weights, or the same laptop scores differently depending on where you looked
// at it.
export const SCALERS = {
  cinebench_2024: 5,
  review_power_efficiency: 2.0,
  three_d_mark_time_spy_g: 5,
  review_energy_efficiency: 2.0,
  // Lever 1 (partly-to-yes-conversion.md): raised from 3 so a spec-appropriate config
  // (32GB/1TB) outranks a cheaper/lighter 16GB/512GB sibling that the ranker used to
  // lead with. RAM is the bigger recurring complaint, so it goes to performance's 5.
  // (A cheap-trio experiment raised storage 4→5 to chase 512GB-for-media misses, but
  // it fixed none of them — those #1s are budget/catalog-bound, not weight-bound — and
  // flipped a weight-first user onto a heavier machine, so it was reverted to 4.)
  storage_size_gigabytes: 4,
  ram_size_gigabytes: 5,
  // Portability re-rank: weight_kg is LOWER_IS_BETTER server-side but is only actually
  // scored when a reference weight_kg target is sent — which algorithm.ts does only for
  // portability-priority / mobile users. Default 0 keeps it fully inert everywhere else.
  weight_kg: 0,
  num_of_usb_a: 1.0,
  num_of_usb_c: 1.0,
  resolution: 1.0,
  storage_type: 1.0,
  operating_system: 1.0,
  wifi_version: 1,
  booltooth_version: 1,
  form_factor: 1.0,
  has_hdmi: 1.0,
  has_ethernet: 1,
  has_mini_display_port: 1,
  has_card_reader: 1,
  has_finger_print_reader: 1,
  has_speakers: 1,
  is_business_grade: 1,
};

export type RecommendationScalers = typeof SCALERS;
